"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const React = __importStar(require("react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const RadioInput = ({ ariaLabel, id, name, label, checked, className, value, onChange, }) => (React.createElement("div", { className: carabiners_1.joinStr(styles_scss_1.default.radio, className) },
    React.createElement("input", { "aria-label": `${ariaLabel}-${id}`, id: id, name: name, type: "radio", checked: checked, value: value, onChange: onChange }),
    React.createElement("label", { htmlFor: id, className: styles_scss_1.default.radioLabel }, label)));
RadioInput.defaultProps = {
    className: '',
    onChange: undefined,
    checked: false,
    id: undefined,
    label: ''
};
exports.default = RadioInput;
